module.exports = "/legacy/dc8baafa4b1d8dc39725fd1ea21ca930.svg";